import React, { useEffect, useState } from "react";
import { useToaster } from "../../context/ToasterContext";
import ShareOnEmail from "../../assets/images/share-icons/email.png";
import ShareOnMessenger from "../../assets/images/share-icons/messenger.png";
import ShareOnWhatsapp from "../../assets/images/share-icons/whatsapp.png";
import ShareOnLine from "../../assets/images/share-icons/line.png";
import ShareOnTelegram from "../../assets/images/share-icons/telegram.png";
import ShareOnImessage from "../../assets/images/share-icons/imessage.png";
import { ReactComponent as CopyToClipboardIcon } from "../../assets/icons/copy-to-clipboard.svg";

const CopyAndShareLinks = ({ order_type, link_url, view_mode='fixed' }) => {
  const { toaster } = useToaster();

  const [copyLinkOnClipboard_link_url, set_copyLinkOnClipboard_link_url] = useState("");

  const removeQueryParams = (url, paramsToRemove) => {
    const parsedUrl = new URL(url);
    paramsToRemove.forEach(param => parsedUrl.searchParams.delete(param));
    return parsedUrl.toString();
  }
  
  useEffect(() => {
    if(link_url.indexOf('redirect_status') > -1){
      link_url = link_url.replace('redirect_status','r_s');
    }

    link_url = removeQueryParams(link_url, ['payment_intent', 'payment_intent_client_secret', 'redirect_status', 'r_s']);
    
    set_copyLinkOnClipboard_link_url(link_url);
  }, [link_url]);

  const copyPaymentLinkOnClipboard = () => {
    /* if(link_url.indexOf('redirect_status') > -1){
      link_url = link_url.replace('redirect_status','r_s');
    }

    link_url = removeQueryParams(link_url, ['payment_intent', 'payment_intent_client_secret', 'redirect_status', 'r_s']); */
    
    navigator.clipboard.writeText(copyLinkOnClipboard_link_url)
      .then(() => toaster.success("Link copied to clipboard!"))
      .catch((err) => toaster.error("Something went wrong"));
  };

  const sharePaymentLinkOnSocialMedia = (channel) => {
    if(link_url.indexOf('redirect_status') > -1){
      link_url = link_url.replace('redirect_status','r_s');
    }

    link_url = removeQueryParams(link_url, ['payment_intent', 'payment_intent_client_secret', 'redirect_status', 'r_s']);

    const subject = encodeURIComponent("Payment link");

    let shareMessage = "Your turn to pay your part 💸 — join the checkout: ";
    //pending-TODO (once we have cart info.: "Your turn to pay your part 💸 for <cart_item> — join the checkout: ")
    if(order_type === 'fixed_payforme'){
      shareMessage = " Hey! I've set up a checkout just for me — mind covering this one? You can pay directly here: 🙏 ";
    }

    const message = shareMessage + " " + link_url;
    const encodedMessage = encodeURIComponent(message);

    const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);

    if (channel === "whatsapp") {
      const url = isMobile
        ? "whatsapp://send?text=" + encodedMessage
        : "https://wa.me/?text=" + encodedMessage;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    else if (channel === "messenger") {
      const url = isMobile
        ? "fb-messenger://share?link=" + encodeURIComponent(link_url)
        : "https://m.me/?text=" + encodedMessage;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    else if (channel === "telegram") {
      const url = isMobile
        ? "tg://msg?text=" + encodedMessage
        : "https://t.me/share/url?url=" + encodeURIComponent(link_url) + "&text=" + encodeURIComponent(shareMessage);
      window.open(url, "_blank", "noopener,noreferrer");
    }
    else if (channel === "imessage") {
      const url = "sms:&body=" + encodedMessage;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    else if (channel === "line") {
      const url = isMobile
        ? "line://msg/text/" + encodedMessage
        : "https://line.me/R/msg/text/?" + encodedMessage;
      window.open(url, "_blank", "noopener,noreferrer");
    }
    else if (channel === "email") {
      const url = "mailto:?subject=" + subject + "&body=" + encodedMessage;
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className={`copyShareLinkContainer whiteCard view_mode___${view_mode}`}>
      <p className="note text-start">Share link</p>
      <hr className="my-2" />

      <div className="row gx-2">
        <div className="col-4">
          <div className="singleShareIconContainer" id="share-on-whatsapp" onClick={() => sharePaymentLinkOnSocialMedia("whatsapp")}>
            <img src={ShareOnWhatsapp} alt="" />
          </div>
        </div>
        <div className="col-4">
          <div className="singleShareIconContainer" id="share-on-imessage" onClick={() => sharePaymentLinkOnSocialMedia("imessage")}>
            <img src={ShareOnImessage} alt="" />
          </div>
        </div>
        <div className="col-4">
          <div className="singleShareIconContainer" id="share-on-messenger" onClick={() => sharePaymentLinkOnSocialMedia("messenger")}>
            <img src={ShareOnMessenger} alt="" />
          </div>
        </div>
        <div className="col-4">
          <div className="singleShareIconContainer" id="share-on-line" onClick={() => sharePaymentLinkOnSocialMedia("line")}>
            <img src={ShareOnLine} alt="" />
          </div>
        </div>
        <div className="col-4">
          <div className="singleShareIconContainer" id="share-on-telegram" onClick={() => sharePaymentLinkOnSocialMedia("telegram")}>
            <img src={ShareOnTelegram} alt="" />
          </div>
        </div>
        <div className="col-4">
          <div className="singleShareIconContainer" id="share-on-email" onClick={() => sharePaymentLinkOnSocialMedia("email")}>
            <img src={ShareOnEmail} alt="" />
          </div>
        </div>
        <div className="col-12">
          <div className="singleShareIconContainer copyLinkToClipboard" id="copy-link-to-clipboard" onClick={copyPaymentLinkOnClipboard}>
            <CopyToClipboardIcon className="align-middle" />
            <span className="align-middle">Copy link</span>
          </div>

          <input type="hidden" id="copy-link-to-clipboard-url-text" value={copyLinkOnClipboard_link_url} />
        </div>
      </div>
    </div>
  );
};

export default CopyAndShareLinks;
